import React from 'react';

export interface StatValueProps {
  value: number;
  className?: string;
}

export const StatValue = ({
  value,
  className = '',
}: StatValueProps) => {
  return (
    <div className={`text-6xl font-bold text-white mb-2 drop-shadow-lg break-words ${className}`}>
      {value}
    </div>
  );
};

